import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import {
  sendRequest,
  changeDefaultQueryParams
} from 'mt-react-common/common/reducers/list/reducer';

import TasksListNewTasks from '../../../../../components/Tasks/TasksListNewTasks';

class HiddenTasksList extends Component {
  constructor(props) {
    super(props);
    this.props.changeDefaultQueryParams({
      page: 1,
      sort: '-created_at'
    });
    this.props.sendRequest();
  }

  render() {
    return <TasksListNewTasks reducerName={this.props.listReduceName} />;
  }
}

HiddenTasksList.propTypes = {
  // IN
  listReduceName: PropTypes.string.isRequired,

  // CONNECT
  changeDefaultQueryParams: PropTypes.func.isRequired,
  sendRequest: PropTypes.func.isRequired
};

HiddenTasksList.contextTypes = {
  router: PropTypes.shape()
};

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch, props) => ({
  changeDefaultQueryParams: queryParams =>
    dispatch(changeDefaultQueryParams(props.listReduceName, queryParams)),
  sendRequest: () => dispatch(sendRequest(props.listReduceName))
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(HiddenTasksList)
);



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/EarnMoney/HiddenTasksList/HiddenTasksList.js